export const serverRuntimeConfig = {
  graphqlApi: {
    url: process.env.NEXT_PUBLIC_GRAPHQL_API_URL,
    key: process.env.GRAPHQL_API_KEY,
  },
  invalidDeliveryKeys: process.env.INVALID_DELIVERY_KEYS?.split(',') ?? [],
  revalidate: {
    secret: process.env.REVALIDATE_SECRET,
    pageTime: Number(process.env.REVALIDATE_PAGE_TIME) || 14400,
    layoutTime: Number(process.env.REVALIDATE_LAYOUT_TIME) || 86400,
    searchTime: Number(process.env.REVALIDATE_SEARCH_TIME) || 300,
  },
  reCaptcha: {
    secret: process.env.GOOGLE_RECAPTCHA_SECRET_KEY,
  },
};
